<template>
    <div class="shenbao">
        <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            label-width="200px"
        >
            <el-form-item label="申报项目名称" prop="title">
                <el-input v-model="dataForm.title" placeholder="申报项目名称"></el-input>
            </el-form-item>
            <el-form-item label="申报页面访问URL中的key值" prop="keyUrl">
                <el-input v-model="dataForm.keyUrl" placeholder="申报页面访问URL中的key值"></el-input>
            </el-form-item>
            <el-form-item label="实验模式" prop="expMode">
                <el-select v-model="dataForm.expMode" placeholder="请选择实验模式">
                    <el-option
                        v-for="item in model"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关联封面图" prop="imgUrl">
                <el-upload
                    action="/api/file/uploadFile"  
                    accept=".png,.jpg,.jpeg"
                    ref="uploadImg"
                    :before-upload="beforeUploadImg" 
                    list-type="picture-card"
                    :limit="1"
                    :headers="headers"
                    :file-list="imgList"
                    :on-success="handleImgSuccess" 
                    :on-exceed="handleExceed"
                    :on-remove="handRemove">
                    <div slot="tip" class="el-upload__tip">只能上传JPG,PNG文件，且大小不超过2MB</div>
                    <i  class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="关联视频" prop="videoUrl">
                <div class="shenbao_video" v-if="dataForm.videoUrl && videoFlag == false">
                    <video :src="dataForm.videoUrl | filterUrl" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
                    <el-button style="margin:12px 0" type="success" @click="againUpload('video')">重新上传</el-button>
                </div>
                <el-upload class="avatar-uploader el-upload--text" 
                    v-if="!dataForm.videoUrl"
                    action="/api/file/uploadFile"  
                    accept=".mp4"
                    :on-success="handleVideoSuccess" 
                    :limit="1"
                    :before-upload="beforeUploadVideo" 
                    :headers="headers"
                    :on-exceed="handleExceed"
                    :file-list="videoList"
                    :show-file-list="false"
                    :on-progress="uploadVideoProcess" 
                    >
                    <div slot="tip" class="el-upload__tip">只能上传MP4文件，且大小不超过20MB</div>
                    <i  class="el-icon-plus avatar-uploader-icon"></i>
                    <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:30px;"></el-progress>
                </el-upload>
                <el-input v-model="dataForm.videoUrl" placeholder="视频的链接" ></el-input>
            </el-form-item>
            
            <el-form-item label="教学引导" prop="guideVideo">
                <div class="shenbao_video" v-if="dataForm.guideVideo && guideVideoFlag == false">
                    <video :src="dataForm.guideVideo | filterUrl" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
                    <el-button style="margin:12px 0" type="success" @click="againUpload('guideVideo')">重新上传</el-button>
                </div>
                <el-upload class="avatar-uploader el-upload--text" 
                    v-if="!dataForm.guideVideo"
                    accept=".mp4"
                    action="/api/file/uploadFile"  
                    :on-success="handleGuideVideoSuccess" 
                    :limit="1"
                    :before-upload="beforeUploadVideo" 
                    :headers="headers"
                    :on-exceed="handleExceed"
                    :file-list="guideVideoList"
                    :show-file-list="false"
                    :on-progress="uploadGuideVideoProcess" 
                    >
                    <i  class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">只能上传MP4文件，且大小不超过20MB</div>
                    <el-progress v-if="guideVideoFlag == true" type="circle" :percentage="guideVideoUploadPercent" style="margin-top:30px;"></el-progress>
                </el-upload>
                <el-input v-model="dataForm.guideVideo" placeholder="视频的链接" @input="guideInputChange"></el-input>
            </el-form-item>
            <el-form-item label="项目介绍PDF" prop="introPdf">
                <el-upload
                    class="upload-demo"
                    action="/api/file/uploadFile" 
                    accept=".pdf"
                    :limit="1"
                    :headers="headers"
                    :on-success="handlePDFSuccess" 
                    :on-exceed="handleExceed"
                    :before-upload="beforeUploadPDF"
                    :on-remove="handPDFRemove"
                    :file-list="pdfList"
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传PDF文件，且大小不超过20MB</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="项目简介">
                <!-- <el-input type="textarea" :rows="5" v-model="dataForm.synopsis" placeholder="项目简介"></el-input> -->
                <vue2editor v-model="dataForm.synopsis" @onchange="onchange"></vue2editor>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch v-model="dataForm.status" :active-value="1" :inactive-value="0" active-text="已发布" inactive-text="未发布">
                </el-switch>
            </el-form-item>
        </el-form>
        <div style="text-align:right">
            <el-button @click="$emit('close')">取消</el-button>
            <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </div>
    </div>
</template>

<script>
import { duplicateCheck, add, update, getEntity } from "@/api/shenbao/shenbao";
import vue2editor from "@/components/common/vue2editor";
import { getToken } from '@/utils/auth'
export default {
    props: {
        shenbaoId:{
            type:String,
            default: ''
        }
    },
    data() {
        const validatekey = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入访问Url中的key值"));
            } else if (!/^[_a-zA-Z0-9]+$/.test(value)) {
                callback(new Error("key值中不允许包含特殊符号"));
            } else {
                //远程验证key名称是否存在
                duplicateCheck({ id: this.dataForm.id, keyUrl: value }).then(res => {
                        if (res) {
                            callback(new Error("key已存在，请重新输入"));
                        }
                        callback();
                    }
                );
            }
        };
        return {
            headers: {
                token: getToken()  //携带token上传,不然会报错
            },
            videoUploadPercent:0,
            guideVideoUploadPercent:0,
            videoFlag: false,
            guideVideoFlag:false,
            dataForm:{},
            visible: false,
            imgList: [],
            videoList: [],
            guideVideoList:[],
            pdfList:[],
            model: [
                { id: 0, label: "远程" },
                { id: 1, label: "本地" },
                { id: 2, label: "全部" }
            ],
            status: [
                { value: 0, label: "未发布" },
                { value: 1, label: "已发布" }
            ],
            dataRule: {
                title: [
                    {
                        required: true,
                        message: "申报项目名称不能为空",
                        trigger: "blur"
                    }
                ],
                deptId: [
                    {
                        required: true,
                        message: "组织机构(部门)ID不能为空",
                        trigger: "blur"
                    }
                ],
                inchargeId: [
                    {
                        required: true,
                        message: "负责人不能为空",
                        trigger: "blur"
                    }
                ],
                keyUrl: [
                    {
                        required: true,
                        validator: validatekey,
                        trigger: "blur"
                    }
                ],
                expMode: [
                    {
                        required: true,
                        message: "实验模式  0 远程  1 本地  2 全部不能为空",
                        trigger: "blur"
                    }
                ],
                createTime: [
                    {
                        required: true,
                        message: "创建时间不能为空",
                        trigger: "blur"
                    }
                ],
                updateTime: [
                    {
                        required: true,
                        message: "修改时间不能为空",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        'shenbaoId':{
            deep:true,
            immediate:true,
            handler: function(newVal) {
                this.imgList = []
                this.videoList = []
                this.guideVideoList = []
                this.pdfList = []
                if(newVal) this.getEntity(newVal)
                else this.dataForm = {
                    expMode: 0,
                    status:0
                }
            }
        },
    },
    components:{
        vue2editor
    },
    methods: {
        againUpload(k){
            if(k=='video') {
                this.$set(this.dataForm,'videoUrl',"")
                this.videoList = []
            }else if(k=='guideVideo'){
                this.guideVideoList = []
                this.$set(this.dataForm,'guideVideo',"")
            }
        },
        onchange(txt){
            this.$set(this.dataForm,'synopsis',txt)
        },
        guideInputChange(val){
            if(val == ""){
                this.guideVideoList = []
                this.dataForm.guideVideo = ""
            }
        },
        videoInputChange(val){
            if(val == ""){
                this.dataForm.videoUrl = ""
                this.videoList = []
            }
        },
        handleImgSuccess(res){
            let obj = new Object
            if(res.data){
                this.$set(this.dataForm,'imgUrl',res.data.originalPath)
                obj.url = this.$options.filters["filterUrl"](res.data.originalPath);
                this.imgList.push(obj)
            }else{
                this.$message.error('图片上传失败，请重新上传！');
            }
        },
        handleVideoSuccess(res){
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            if(res.data){
                this.$set(this.dataForm,'videoUrl',this.$options.filters["filterUrl"](res.data.originalPath))
            }else{
                this.$message.error('视频上传失败，请重新上传！');
            }
        },
        handleGuideVideoSuccess(res){
            this.guideVideoFlag = false;
            this.guideVideoUploadPercent = 0;
            if(res.data){
                this.$set(this.dataForm,'guideVideo',this.$options.filters["filterUrl"](res.data.originalPath))
            }else{
                this.$message.error('视频上传失败，请重新上传！');
            }
        },
        handlePDFSuccess(res){  //上传PDF成功时
            let obj = new Object
            if(res.data){
                this.$set(this.dataForm,'introPdf', res.data.originalPath)
                obj.url = this.$options.filters["filterUrl"](res.data.originalPath);
                this.imgList.push(obj)
            }else{
                this.$message.error('图片上传失败，请重新上传！');
            }
        },
        handPDFRemove(){  //删除上传的PDF时
            this.pdfList = []
            this.$set(this.dataForm,'introPdf',"")
        },
        beforeUploadPDF(file){  //上传PDF之前
            const is20M = file.size / 1024 / 1024  < 20;
            if (['application/pdf'].indexOf(file.type) == -1) {
                this.$message.error('请上传PDF文件格式!');
                return false;
            }
            if (!is20M) {
                this.$message.error('上传资源大小不能超过20MB!');
                return false;
            }   
        },
        beforeUploadImg(file){
            const is2M = file.size / 1024 / 1024  < 2;
            if (['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) == -1) {
                this.$message.error('请上传JPG或者PNG的图片格式');
                return false;
            }
            if (!is2M) {
                this.$message.error('上传图片大小不能超过2MB!');
                return false;
            }
        },
        beforeUploadVideo(file){
            const is20M = file.size / 1024 / 1024  < 20;
            if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
                this.$message.error('请上传正确的视频格式');
                return false;
            }
            if (!is20M) {
                this.$message.error('上传视频大小不能超过20MB!');
                return false;
            }
        },
        uploadVideoProcess(event){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        uploadGuideVideoProcess(event){
            this.guideVideoFlag = true
            this.guideVideoUploadPercent = Math.floor(event.percent)
        },
        handleExceed () {
            this.$message.warning('请先删除之前的资源，再上传新的资源!');
        },
        handRemove(){
            this.imgList = []
            this.$set(this.dataForm,'imgUrl',"")
        },
        getEntity(id){
            getEntity(id).then(res=>{
                this.dataForm = res
                let obj = new Object
                let PDFobj = new Object
                if (res.imgUrl) {
                    obj.url = this.$options.filters["filterUrl"](res.imgUrl);
                    this.imgList.push(obj)
                }
                if (res.videoUrl) {
                    this.$set(this.dataForm,'videoUrl',res.videoUrl)
                }

                if(res.guideVideo) {
                    this.$set(this.dataForm,'guideVideo',res.guideVideo)
                }

                if (res.introPdf) {
                    PDFobj.url = res.introPdf
                    PDFobj.name = 'PDF文件'
                    this.pdfList.push(PDFobj)
                }
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    let opFun = this.dataForm.id ? update : add;
                    opFun(this.dataForm).then(() => {
                        this.$message.success("操作成功");
                        this.$emit('close')
                    });
                } else return false;
            });
        },
    }
};
</script>
<style lang="less">
.shenbao{
    .shenbao_video{
        video{
            width: 420px;
        }
    }
    
}
</style>
